import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Entender la Etapa',
  subtitle: 'Comprende lo que realmente está pasando y deja de reaccionar sin claridad',
  accent: 'border-l-blue-500',
  items: ['Cambios físicos y cognitivos', 'Psicología del envejecimiento', 'Cómo gestionar tus propias emociones', 'El rol de los hijos en esta etapa', 'Aceptación y empatía', 'Base sólida para acompañar']
}, {
  icon: '🟢',
  title: 'Tomo 2 — Comunicación',
  subtitle: 'Aprende a hablar sin conflicto y abordar conversaciones difíciles',
  accent: 'border-l-green-500',
  items: ['Técnicas de comunicación asertiva', 'Cómo hablar de salud y dinero', 'Evitar la infantilización', 'Escucha activa y validación', 'Manejo de la resistencia al cambio', 'Acuerdos sin discusiones']
}, {
  icon: '🟡',
  title: 'Tomo 3 — Organización Familiar',
  subtitle: 'Ordena responsabilidades, decisiones y roles',
  accent: 'border-l-yellow-400',
  items: ['Distribución de tareas entre hermanos', 'Gestión de tiempos y recursos', 'Calendario de cuidados compartido', 'Roles claros para evitar conflictos', 'Reuniones familiares efectivas', 'Equilibrio en la carga']
}, {
  icon: '🟣',
  title: 'Tomo 4 — Decisiones Difíciles',
  subtitle: 'Actúa con seguridad en momentos complejos',
  accent: 'border-l-purple-500',
  items: ['Cuándo es momento de pedir ayuda extra', 'Opciones de vivienda y cuidados', 'Seguridad en el hogar', 'Autonomía vs. Seguridad', 'Criterios para decidir con calma', 'Protocolos de actuación']
}, {
  icon: '🔴',
  title: 'Tomo 5 — Cuidado y Límites',
  subtitle: 'Acompaña sin agotarte ni perderte en el proceso',
  accent: 'border-l-red-500',
  items: ['Prevención del síndrome del cuidador', 'Establecer límites saludables', 'Autocuidado sostenible', 'Redes de apoyo externas', 'Gestión del tiempo personal', 'Cuidado con amor y salud']
}, {
  icon: '🟤',
  title: 'Tomo 6 — Preparación a Futuro',
  subtitle: 'Anticípate y evita crisis innecesarias',
  accent: 'border-l-amber-800',
  items: ['Planificación legal y financiera', 'Deseos y voluntades anticipadas', 'Organización de documentos clave', 'Prevención de emergencias', 'Tranquilidad para el largo plazo', 'Legado y acompañamiento final']
}];
const features = ['Ejercicios prácticos aplicables', 'Estrategias listas para usar', 'Ejemplos reales', 'Lenguaje claro y directo', 'Aplicación inmediata en tu vida familiar'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-320">
      <div className="max-w-xl mx-auto" data-id="element-321">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-322">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-323">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-324">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-325">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-326">
                  <span className="text-2xl flex-shrink-0" data-id="element-327">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-328">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-329">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-330">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-331" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-332" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-333">
                    <div className="space-y-2" data-id="element-334">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-335">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-336" />
                          <span className="text-xs text-gray-400" data-id="element-337">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-338">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-339">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-340">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-341">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-342" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-343">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}